import React from 'react'
import { DataGrid,
 } from '@mui/x-data-grid';
       
import { withStyles } from "@material-ui/core/styles";

const StyledDataGrid = withStyles({
  
    root: {
      backgroundColor:'#FFFFFF',
      direction:"rtl",
      "& .MuiDataGrid-renderingZone": {
        maxHeight: "none !important",
        

      },
      "& .MuiDataGrid-cell": {
        lineHeight: "unset !important",
        maxHeight: "none !important",
        whiteSpace: "normal"
      },
      "& .MuiDataGrid-row": {
        maxHeight: "none !important"
      }
    }
  })(DataGrid);

  

export default StyledDataGrid

